// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ac688662","977":"ace4e406"}[chunkId] + ".chunk.js";
};